<div *ngIf="content.cards">
  <div class="skymiles-landing-page-offers">
    <idp-card
      *ngFor="let card of content.cards"
      [contents]="card"
      (notify)="clickAnalyticsEvent.emit(card)"
    ></idp-card>
  </div>
</div>
